<template>
  <div>
    <nav-bar/>
    <div class="pt-4 mx-3">

      <div class="card">
        <div class="card-header">
          <h3 class="my-2"> {{$t('logs.title')}}</h3>
        </div>
        <paginate-links @change="setLastPage" for="filterResults" :hide-single-page="true" :limit="5"></paginate-links>
        <paginate :refreshCurrentPage="false" ref="paginator" name="filterResults" tag="div" :list="filterResults" class="" :per="30">
        <div v-if="reversedLogs.length > 0" class="table-responsive">
          <table class="table table-hover font-grey mb-0 table-sm">
            <thead class="bg-darkgrey">
              <tr>
                <!-- <th @click="sortBy('orderNb', false)" class="sortable nowrap">{{$t('OrderCurrent.order')}}<i v-if="sort.current === 'orderNb'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('reference', false)" class="sortable nowrap">{{$t('OrderCurrent.reference')}}<i v-if="sort.current === 'reference'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('source', false)" class="sortable nowrap">{{$t('OrderCurrent.source')}}<i v-if="sort.current === 'source'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('vin', false)" class="sortable nowrap">{{$t('OrderCurrent.VIN')}}<i v-if="sort.current === 'vin'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('date', false)" class="sortable nowrap">{{$t('OrderCurrent.date')}}<i v-if="sort.current === 'date'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('pickup', false)" class="sortable nowrap">{{$t('OrderCurrent.pickup')}}<i v-if="sort.current === 'pickup'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('delivery', false)" class="sortable nowrap">{{$t('OrderCurrent.delivery')}}<i v-if="sort.current === 'delivery'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('billing', false)" class="sortable nowrap">{{$t('OrderCurrent.billing')}}<i v-if="sort.current === 'billing'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('status', false)" class="sortable nowrap">{{$t('OrderCurrent.status')}}<i v-if="sort.current === 'status'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('driver', false)" class="sortable nowrap">{{$t('OrderCurrent.driver')}}<i v-if="sort.current === 'driver'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th> -->
                <th>{{$t('logs.table_header.user')}}</th>
                <th>{{$t('logs.table_header.action')}}</th>
                <th>{{$t('logs.table_header.date')}}</th>
                <th>{{$t('logs.table_header.target')}}</th>
              </tr>
            </thead>
            <transition-group name="fade" tag="tbody">
              <tr key='filter'>
                <td>
                  <regular-input
                    :value="fields.userName"
                    @input="evaluateFiltering('userName', $event)"
                    :placeholder="$t('logs.table_header.user')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.action"
                    @input="evaluateFiltering('action', $event)"
                    :placeholder="$t('logs.table_header.action')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.date"
                    @input="evaluateFiltering('date', $event)"
                    :placeholder="$t('logs.table_header.date')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.target"
                    @input="evaluateFiltering('target', $event)"
                    :placeholder="$t('logs.table_header.target')"/>
                </td>
              </tr>
              <tr v-for="log in paginated('filterResults')" :key="log['.key']">
                <td>{{getUserName(log.UID)}}</td>
                <td>{{$t('logs.action.' + log.action)}}{{log.status ? ': ' + log.status : ''}}{{log.targetName ? ': ' + log.targetName : ''}}</td>
                <td>{{getDate(log.date)}}</td>
                <td>{{log.orderID || log.modifiedUserName || log.customerName || log.targetName || log.createdUserName}}</td>
              </tr>
            </transition-group>
          </table>
        </div>
        </paginate>
        <paginate-links @change="setLastPage" for="filterResults" :hide-single-page="true" :limit="5"></paginate-links>
      </div>
    </div>
  </div>
</template>

<script>
import regularInput from '../regularInput.vue'
import regularSelect from '../regularSelect.vue'
import {dbLogs, db} from '../../firebase'
import _ from 'lodash'

export default {
  name: 'Search',
  components: {
    regularInput,
    regularSelect
  },
  data () {
    return {
      filterResults: [],
      search: {},
      paginate: ['filterResults'],
      sort: {
        current: 'orderNb',
        desc: true
      },
      fields: {
        userName: '',
        action: '',
        date: '',
        target: ''
      },
      Logs: [],
      users: []
    }
  },
  created () {
    if (this.isAdmin) {
      this.$bindAsArray('Logs', dbLogs.ref('logs/transporter/' + this.companyUID).limitToLast(1500))
      this.$bindAsArray('users', db.ref('userInfos').child(this.companyUID))
    }
  },
  methods: {
    setLastPage (toPage, fromPage) {
      this.$store.commit('SET_LAST_PAGE', toPage)
    },
    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString('en-US', {timeZone: 'America/New_York'})
    },
    getUserName (uid) {
      if (uid === this.companyUID) return this.$t('logs.admin')
      let user = this.users.find((u) => {
        return u['.key'] === uid
      })
      return user ? user.firstName + ' ' + user.lastName : ''
    },
    sortBy (criteria, newEntry) {
      if (this.sort.current === criteria && !newEntry) {
        this.sort.desc = !this.sort.desc
      } else if (!newEntry) {
        this.sort.desc = true
        this.sort.current = criteria
      }
      this.logs.deliveries.sort((a, b) => {
        if (a[criteria] === undefined) a[criteria] = ''
        if (b[criteria] === undefined) b[criteria] = ''
        var A = a[criteria]
        var B = b[criteria]
        if (criteria !== 'date') {
          A = a[criteria].toUpperCase() // ignore upper and lowercase
          B = b[criteria].toUpperCase() // ignore upper and lowercase
        }
        if (!this.sort.desc) {
          if (A < B) {
            return -1
          }
          if (A > B) {
            return 1
          }
        } else {
          if (A > B) {
            return -1
          }
          if (A < B) {
            return 1
          }
        }
        return 0
      })
    },
    evaluateFiltering (attr, val) {
      this.fields[attr] = val
      this.filteredSearchMethod()
    },
    filteredSearchMethod: _.debounce(function () {
      this.filterResults = []
      this.filterResults = this.reversedLogs.filter((log) => {
        var result = true
        for (var attr in this.fields) {
          if (this.fields[attr] !== '') {
            var reg = this.fields[attr].replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
            var re = new RegExp(reg, 'i')
            if (attr === 'date') {
              result = re.test(this.getDate(log[attr]))
            } else if (attr === 'userName') {
              result = re.test(this.getUserName(log.UID))
            } else if (attr === 'target') {
              result = re.test(log.orderID + ' ' + log.modifiedUserName + ' ' + log.customerName + ' ' + log.targetName + ' ' + log.createdUserName)
            } else {
              result = re.test(this.$t('logs.action.' + log.action) + ' ' + log.status + ' ' + log.targetName)
            }
          }
          if (result === false) break
        }
        return result
      })
      // this.sortBy(this.sort.current, true)
      let paginator = this.$refs.paginator
      let maxPage = Math.ceil(this.filterResults.length / paginator.per)
      if (paginator.currentPage + 1 > maxPage && maxPage !== 0) paginator.goToPage(1)
    }, 100)
  },
  computed: {
    companyUID () {
      return this.$store.state.authorization.company
    },
    reversedLogs () {
      return this.Logs.slice().reverse()
    },
    isAdmin () {
      return this.$store.state.authorization.role === 'Admin'
    }
  },
  watch: {
    reversedLogs () {
      this.filteredSearchMethod()
    }
  }
}
</script>

<style scoped>
.table thead th{
  border-bottom: 1px solid #eceeef;
  border-top: none;
}
input, button{
  cursor: pointer;
}
#addOrder{
  position: fixed;
  right: 1rem;
  bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// Logs.vue?e6e96846